// extracted by mini-css-extract-plugin
export default {"colorContainer":"colorlist_colorContainer__cg+Sv","variantNumber":"colorlist_variantNumber__3Lk06","variantName":"colorlist_variantName__DAzIT"};